module.exports = __webpack_public_path__ + "static/media/img_29.dba3781a.JPG";